import { isMounted as d } from "@sunrise/shared";
import { useScroll as h, useElementBounding as v } from "@vueuse/core";
import { defineComponent as S, ref as r, shallowRef as D, computed as u, onMounted as k, watch as w } from "vue";
const C = S({
  name: "CsStickyContainer",
  props: {
    maxScrollDepth: Number
  },
  emits: ["change:stickiness"],
  setup(t, { emit: i }) {
    const e = r(null), o = D(null), { y: a, directions: m } = h(o, { throttle: 10 }), { top: n } = v(e), s = r(0), f = d(), l = u(() => f.value && n.value <= 0), p = u(() => m.top || !t.maxScrollDepth ? !0 : a.value - s.value < t.maxScrollDepth);
    return k(() => {
      o.value = window.document, e.value && (s.value = n.value);
    }), w(l, (c) => i("change:stickiness", c)), { rootRef: e, isSticky: l, isVisible: p };
  }
});
export {
  C as default
};
